import { create } from 'zustand';
import { useTicketsStore } from '@/features/tickets';
import type { MassIncidentAddResult } from '@/shared/api';

export interface PickerRequest {
  ticketIds: string[];
  categoryId?: string | null;
  subcategoryId?: string | null;
  currentIncidentId?: string | null;
  onDone?: (result: MassIncidentAddResult) => void;
}

interface MassIncidentUiState {
  panel: { incidentId: string } | null;
  picker: PickerRequest | null;
  reply: { incidentId: string; sourceTicketId?: string } | null;
  openPanel: (incidentId: string) => void;
  openPicker: (request: PickerRequest) => void;
  openReply: (incidentId: string, sourceTicketId?: string) => void;
  close: (which: 'panel' | 'picker' | 'reply') => void;
}

export const useMassIncidentUi = create<MassIncidentUiState>((set) => ({
  panel: null,
  picker: null,
  reply: null,
  openPanel: (incidentId) => set({ panel: { incidentId } }),
  openPicker: (request) => set({ picker: request }),
  openReply: (incidentId, sourceTicketId) => set({ reply: { incidentId, sourceTicketId } }),
  close: (which) => set({ [which]: null } as Partial<MassIncidentUiState>),
}));

export function refreshAfterIncidentChange(incidentId: string, ticketIds: string[] = []): void {
  const s = useTicketsStore.getState();
  if (s.fetchedAt > 0) void s.fetchTickets(s.lastParams);
  const current = s.currentTicket;
  if (current && (ticketIds.includes(current.id) || current.massIncidentId === incidentId)) {
    void s.fetchTicket(current.id);
  }
}
